import { useNavigate, useLocation } from 'react-router-dom';
import { useCountry } from '@/contexts/country';
import { BreadcrumbItem } from '@/components/navigation/UnifiedBreadcrumbs';

export const useUnifiedNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { availableCountries, selectedCountry, setCountry } = useCountry();

  const handleCountryChange = (countryCode: string) => {
    setCountry(countryCode);
    
    // Determine the current resource type and navigate to the same type for the new country
    if (location.pathname.includes('/insights')) {
      navigate(`/insights/${countryCode}`);
    } else if (location.pathname.includes('/polls')) {
      navigate(`/polls/${countryCode}`);
    } else if (location.pathname.includes('/cards/')) {
      navigate(`/cards/${countryCode}`);
    } else {
      // Default to country page for other cases
      navigate(`/cards/${countryCode}`);
    }
  };

  const generateBreadcrumbs = (
    resourceType: 'insights' | 'polls',
    countryCode?: string,
    countryName?: string
  ): BreadcrumbItem[] => {
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Home', href: '/' },
      { label: 'Countries', href: '/countries' }
    ];

    if (countryCode && countryName) {
      breadcrumbs.push({
        label: countryName,
        href: `/cards/${countryCode}`
      });
    }

    // Add the current resource type as the final breadcrumb
    const resourceLabels = {
      insights: 'Insights',
      polls: 'Polls'
    };

    breadcrumbs.push({
      label: resourceLabels[resourceType],
      isCurrentPage: true
    });

    return breadcrumbs;
  };

  return {
    handleCountryChange,
    generateBreadcrumbs,
    availableCountries,
    selectedCountry
  };
};